import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <section>
      <h1 className="text-2xl font-semibold">Not found</h1>
      <p className="mt-2 text-slate-700 dark:text-slate-300">
        That page doesn&apos;t exist.{" "}
        <Link to="/" className="text-brand-600 hover:underline dark:text-brand-500">
          Back to home
        </Link>
        .
      </p>
    </section>
  );
}
